import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  market: "ozon", // 'ozon' | 'wb' | 'ym'
  status: "awaiting_packaging", // 'awaiting_packaging' | 'ready_for_shipment' | 'delivering' | 'delivered' | 'cancelled'
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setMarket(state, action) {
      state.market = action.payload;
    },
    setStatus(state, action) {
      state.status = action.payload;
    },
  },
});

export const { setMarket, setStatus } = uiSlice.actions;
export default uiSlice.reducer;
